import React, { Component as Component } from 'react';

export default class Body extends Component {

	render() {
		return <div className="modal-body">
			{ this.props.children }
		</div>
	}
}


// WEBPACK FOOTER //
// ./src/modules/utils/Body.js